<template>
  <div>
    <div class="descriptions">
      <div class="title">基本信息</div>
      <div class="box">
        <a-row :gutter="[0,12]">
          <a-col><span>性别：</span><b>{{ expertInfo.extras.genderText }}</b></a-col>
          <a-col><span>出生日期：</span><b>{{ expertInfo.birthdate }}</b></a-col>
          <a-col><span>紧急联系电话：</span><b>{{ expertInfo.emergencyMobilePhone }}</b>
          </a-col>
          <a-col><span>电子邮箱：</span><b>{{ expertInfo.email }}</b></a-col>
          <a-col><span>联系地址：</span><b>{{ expertInfo.address }}</b></a-col>
        </a-row>
      </div>
    </div>

    <div class="descriptions">
      <div class="title">银行信息</div>
      <div class="box">
        <a-row :gutter="[0,12]">
          <a-col><span>银行账号：</span><b>{{ expertInfo.bankAccount }}</b></a-col>
          <a-col><span>开户银行：</span><b>{{ expertInfo.openingBank }}</b></a-col>
        </a-row>
      </div>
    </div>

    <div class="descriptions">
      <div class="title">工作信息</div>
      <div class="box">
        <a-row :gutter="[0,12]">
          <a-col :span="6"><span>是否在职：</span><b>{{ expertInfo.extras.incumbencyText }}</b></a-col>
          <a-col :span="16"><span>{{ expertInfo.isIncumbency === '1' ? '当前工作单位全称' : '退休单位' }}：</span><b>{{
              expertInfo.unitName
            }}</b></a-col>
          <template v-if="expertInfo.isIncumbency==='0'">
            <a-col><span>退休时间：</span><b>{{ expertInfo.retireDate |dayjs('YYYY年MM月') }}</b></a-col>
            <a-col><span>退休时长：</span><b>{{ expertInfo.extras.retireYearMonth }}</b></a-col>
          </template>
          <template v-else>
            <a-col><span>当前工作单位性质：</span><b>{{ expertInfo.extras.unitPropertiesText }}</b></a-col>
            <a-col><span>职务：</span><b>{{ expertInfo.position }}</b></a-col>
          </template>
        </a-row>
      </div>
    </div>
    <div class="descriptions">
      <div class="title">专业领域</div>
      <a-row :gutter="[0,12]">
        <a-col :span="24" v-if="expertInfo.otherSourceLibrary">
          <div class="box">
            <span>其他专家库：</span><b style="color: red">{{ expertInfo.extras.otherSourceLibraryText }}成员</b>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="box">
            <span>评审品目：</span><b style="color: blue">{{ expertInfo.purchaseItem }}</b>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="box">
            <a-row :gutter="[0,12]">
              <a-col><span>毕业院校：</span><b>{{ expertInfo.school }}</b></a-col>
              <a-col><span>最高学历：</span><b>{{ expertInfo.extras.educationText }}</b>
              </a-col>
              <a-col><span>职称水平：</span><b>{{ expertInfo.extras.professionalTitleText }}</b>
              </a-col>
              <a-col :span="24"><span>职称名称：</span><b>
                <template v-if="expertInfo.specificProfessionalTitle">
                  {{`${expertInfo.specificProfessionalTitle}
                    ${expertInfo.otherSpecificProfessionalTitle ? `；${expertInfo.otherSpecificProfessionalTitle}` : ''}`
                  }}
                </template>
                <template v-else>
                  {{ expertInfo.otherSpecificProfessionalTitle || '' }}
                </template>
              </b>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="box">
            <span>专业领域：</span><b>{{ expertInfo.skilledProfession }}</b>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="box">
            <span>学术成果：</span><b>{{ expertInfo.majorResult }}</b>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="box">
            <span>获得奖励：</span><b>{{ expertInfo.reward }}</b>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BasicInfoView',
  components: {},
  props: {
    expertInfo: {
      type: Object,
      default: () => {
        return { extras: {} }
      }
    },
  },
  computed: {},
  data () {
    return {}
  },
  created () {
  },
  methods: {}
}
</script>

<style></style>
